<template>
    <a href="#" :class="isLikingClasses" @click.prevent="toggleLike(entity_id)">
        <span v-if="signed_in" class="icon-thumbs-up"></span><span v-if="signed_in">{{ likeText }}</span>
    </a>
</template>

<script>
import axios from 'axios';

export default {
    props: {
        url: String,
        likes: Number,
        isLiking: Boolean,
        entity_id: Number,
        signed_in: Boolean
    },

    data: function () {
        return {
            disableButton: false,
            propIsLiking: false,
            propLikes: []
        };
    },

    mounted() {
        this.propIsLiking = this.isLiking;
        this.propLikes = this.likes;
    },

    computed: {
        likeText: function () {
            if (this.propIsLiking) {
                return 'Gillar';
            } else {
                return 'Gilla';
            }
        },

        isLikingClasses: function () {
            return {
                'like-post-button': true,
                btn: true,
                off: this.isLiking,
                on: !this.isLiking
            };
        }
    },

    methods: {
        toggleLike: function (id) {
            if (this.disableButton) return;

            this.disableButton = true; // Disable button

            this.propIsLiking = !this.propIsLiking;

            this.increaseOrDecreaseLikes();

            axios
                .post(this.url, {
                    entity_id: id
                })
                .then((response) => {
                    this.disableButton = false; // Enable button
                })
                .then((err) => {
                    if (err) {
                        this.propIsLiking = !this.propIsLiking;
                        this.increaseOrDecreaseLikes();
                        console.error(err);
                    }
                });
        },

        increaseOrDecreaseLikes: function () {
            if (this.propIsLiking) {
                this.propLikes++;
            } else {
                this.propLikes--;
            }
        }
    }
};
</script>
